import styled from '@emotion/styled';
import Calendar from '@/components/atoms/Calendar';

export const StyledCalendar = styled(Calendar)`
    margin: ${({ theme }) => theme.spacing[4]} 0 ${({ theme }) => theme.spacing[6]};
`;
